module.exports = __webpack_public_path__ + "img/Marketing_case_pic04.844d15b4.png";